import React, { type PropsWithChildren } from 'react';
import { Elements, RecurlyProvider } from '@recurly/react-recurly';
import { getEnv } from '../../utils/environment';

const RecurlyWrapper: React.FunctionComponent<PropsWithChildren> = ({ children }) => (
  // @ts-expect-error - RecurlyProvider dep needs to be updated for this to work
  <RecurlyProvider publicKey={getEnv().recurlyPublicKey}>
    {/* @ts-expect-error - RecurlyProvider dep needs to be updated for this to work */}
    <Elements>{children}</Elements>
  </RecurlyProvider>
);

export default RecurlyWrapper;
